import React from 'react';

import { Svg, Polygon, SvgProps } from 'react-native-svg';

const BenchIcon: React.FC<SvgProps> = (props) => {
  const { width = '100%', height = '100%', color = '#ffffff' } = props;

  return (
    <Svg
      enable-background={'new 0 0 566.93 566.93'}
      viewBox={'0 0 566.93 566.93'}
      width={width}
      height={height}
    >
      <Polygon
        fill={color}
        points={
          '124.4,23.9 18.9,47.5 18.9,70.7 77.7,102 77.7,217.7 8.5,240 0,269 18.9,277.8 199,223.1 190.2,198.8 179.5,189.1 117.2,207.6 117.2,118.7 422,283.5 444.2,293.6 444.2,438.5 342.7,484.7 328.2,524.5 352.7,543 566.9,438.5 559.8,408.5 535.3,393.3 492.3,416.1 492.3,277.8 566.9,240 566.9,212.6 137.9,23.9'
        }
      />
    </Svg>
  );
};

export default BenchIcon;
